import React from "react";

const Footer = () => {
	const currentYear = new Date().getFullYear();

	return (
		<div className="bg-gray-200 flex justify-center space-x-1 w-screen bottom-0 py-1 text-center">
			<p className="text-sm">&copy; {currentYear} All rights reserved. </p>
			<a
				href="https://ibrohimbek-links.vercel.app/"
				target="_blank"
				rel="noopener noreferrer"
				title="Contact Us"
				className="text-sm text-red-500"
			>
				<span>Contact</span> <span>Us</span>
			</a>
		</div>
	);
};

export default Footer;
